import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./MyStyles.css";
import {
    faArrowRightArrowLeft,
    faBell,
    faBoxes,
    faBoxesStacked,
    faBriefcase,
    faCalendarCheck,
    faCartShopping,
    faChartLine,
    faClipboardList,
    faClockRotateLeft,
    faDiagramNext,
    faDiagramProject,
    faDolly,
    faFileCircleCheck,
    faFileInvoice,
    faFileInvoiceDollar,
    faFolderOpen,
    faGaugeHigh,
    faImages,
    faLayerGroup,
    faLeaf,
    faListCheck,
    faMicrochip,
    faMoneyBill,
    faMoneyBillTransfer,
    faMoneyCheckDollar,
    faMountain,
    faNewspaper,
    faRightLeft,
    faRobot,
    faRotateLeft,
    faSeedling,
    faSliders,
    faStar,
    faTags,
    faTasks,
    faThermometerHalf,
    faTimeline,
    faTractor,
    faTriangleExclamation,
    faTruckLoading,
    faUserGear,
    faUsers,
    faUserShield,
    faUserTie,
    faWarehouse
} from "@fortawesome/free-solid-svg-icons";
function Menu() {
    const userGroup = localStorage.getItem("userGroup");
        const MenuCard = ({
                          link, title, icon, color, external = false
                      }) => {
        const card = (<div
                className="menu-card"
                style={{
                    "--menu-color": color
                }}
            >

                {/* Decorative background */}
                <div className="menu-card-bg"></div>

                {/* Hover shine */}
                <div className="menu-card-shine"></div>

                {/* Icon */}
                <div className="menu-icon-area">

                    <FontAwesomeIcon
                        icon={icon}
                        className="menu-large-icon"
                        style={{
                            color: color
                        }}
                    />

                </div>

                {/* Title */}
                <div className="menu-title-area">

                    <span className="menu-title">
                        {title}
                    </span>

                </div>

            </div>);
        return (<div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4">

                {external ? (<a
                        href={link}
                        target="_blank"
                        rel="noreferrer"
                        className="menu-link"
                    >
                        {card}
                    </a>) : (<Link
                        to={link}
                        className="menu-link"
                    >
                        {card}
                    </Link>)}

            </div>);
    };
    return (<section className="menu-section container-fluid mt-4">

        <div className="row">

            {/* ================= ADMIN ================= */}

            {userGroup === "Admin" && (<>

                <MenuCard
                    link="/"
                    title="Admin Dashboard"
                    icon={faChartLine}
                    color="#0d6efd"
                />

                <MenuCard
                    link="/news/"
                    title="News"
                    icon={faNewspaper}
                    color="#20c997"
                />

                <MenuCard
                    link="/todo/"
                    title="To Do"
                    icon={faListCheck}
                    color="#fd7e14"
                />

                <MenuCard
                    link="/user-create/"
                    title="User Profile"
                    icon={faUserTie}
                    color="#6f42c1"
                />
                <MenuCard
                    link="/land-owner/"
                    title="Land Owner"
                    icon={faUserTie}
                    color="#6f42c1"
                />

                <MenuCard
                    link="/worker/"
                    title="Worker"
                    icon={faUserGear}
                    color="#0dcaf0"
                />
                <MenuCard
                    link="/admin-task/"
                    title="Tasks"
                    icon={faTasks}
                    color="#0d6efd"
                />

                <MenuCard
                    link="/admin-dispute/"
                    title="Disputes"
                    icon={faTriangleExclamation}
                    color="#dc3545"
                />
           
                <MenuCard
                    link="/crop-category"
                    title="Crop Category"
                    icon={faSeedling}
                    color="#198754"
                />
                <MenuCard
                    link="/crop"
                    title="Crop Master"
                    icon={faLeaf}
                    color="#198754"
                />
                <MenuCard
                    link="/crop-variety"
                    title="Crop Variety"
                    icon={faSeedling}
                    color="#28a745"
                />
                <MenuCard
                    link="/farmland"
                    title="Farmland"
                    icon={faMountain}
                    color="#8B4513"
                />
                <MenuCard
                    link="/land-crop"
                    title="Land Crop"
                    icon={faSeedling}
                    color="#2E8B57"
                />
                <MenuCard
                    link="/workflow"
                    title="Workflow"
                    icon={faDiagramProject}
                    color="#1565C0"
                />
                <MenuCard

                    link="/workflow-stage"

                    title="Workflow Stage"

                    icon={faDiagramNext}

                    color="#00897B"

                />
                <MenuCard

                    link="/approval-queue"

                    title="Approval Queue"

                    icon={faListCheck}

                    color="#EF6C00"

                />
                <MenuCard

                    link="/workflow-transaction"

                    title="Workflow Transaction"

                    icon={faTimeline}

                    color="#3949AB"

                />
                <MenuCard

                    link="/workflow-history"

                    title="Workflow History"

                    icon={faClockRotateLeft}

                    color="#6A1B9A"

                />
                <MenuCard

                    link="/my-requests"

                    title="My Requests"

                    icon={faFileCircleCheck}

                    color="#2E7D32"

                />
                <MenuCard

                    link="/notification"

                    title="Notification"

                    icon={faBell}

                    color="#D32F2F"

                />
                <MenuCard

                    link="/documents"

                    title="Document Manager"

                    icon={faFolderOpen}

                    color="#5E35B1"

                />
                <MenuCard

                    link="/audit-log"

                    title="Audit Log"

                    icon={faUserShield}

                    color="#263238"

                />

                <MenuCard
                    link="/iot-menu"
                    title="IoT & Patient Monitoring"
                    icon={faMicrochip}
                    color="#0d6efd"
                />
                <MenuCard

                    link="/sensor-reading"

                    title="Sensor Reading"

                    icon={faThermometerHalf}

                    color="#EF6C00"

                />
                <MenuCard

                    link="/analytics-report"

                    title="Analytics Report"

                    icon={faChartLine}

                    color="#6A1B9A"

                />
                <MenuCard

                    link="/kpi"

                    title="KPI Dashboard"

                    icon={faGaugeHigh}

                    color="#2E7D32"

                />
            </>)}

            {/* ================= LAND OWNER ================= */}

            {(userGroup === "Admin" || userGroup === "LandOwner") && (<>
                <MenuCard
                    link="/post-requirement/"
                    title="Requirements"
                    icon={faClipboardList}
                    color="#198754"
                />

                <MenuCard
                    link="/owner-assignments/"
                    title="Assignments"
                    icon={faUsers}
                    color="#dc3545"
                />

                <MenuCard
                    link="/owner-attendance/"
                    title="Attendance"
                    icon={faCalendarCheck}
                    color="#fd7e14"
                />

                <MenuCard
                    link="/owner-payments/"
                    title="Payments"
                    icon={faMoneyBill}
                    color="#198754"
                />
                <MenuCard
                    link="/purchase-request"
                    title="Purchase Request"
                    icon={faClipboardList}
                    color="#1E88E5"
                />
                <MenuCard

                    link="/rfq"

                    title="RFQ"

                    icon={faFileInvoiceDollar}

                    color="#8E24AA"

                />
                <MenuCard
                    link="/supplier-quotation"
                    title="Supplier Quotation"
                    icon={faFileInvoiceDollar}
                    color="#6A1B9A"
                />
                <MenuCard

                    link="/purchase-order"

                    title="Purchase Order"

                    icon={faCartShopping}

                    color="#2E7D32"

                />


                <MenuCard

                    link="/vendor-payment"

                    title="Vendor Payment"

                    icon={faMoneyBillTransfer}

                    color="#00897B"

                />
                <MenuCard

                    link="/purchase-return"

                    title="Purchase Return"

                    icon={faRotateLeft}

                    color="#C62828"

                />
                <MenuCard

                    link="/inventory-category"

                    title="Inventory Category"

                    icon={faLayerGroup}

                    color="#388E3C"

                />

                <MenuCard
                    link="/inventory-item"
                    title="Inventory Item"
                    icon={faBoxesStacked}
                    color="#2E7D32"
                />


                <MenuCard

                    link="/stock-transaction"

                    title="Stock Transaction"

                    icon={faArrowRightArrowLeft}

                    color="#1565C0"

                />
                <MenuCard
                    link="/inventory-transfer"
                    title="Inventory Transfer"
                    icon={faRightLeft}
                    color="#1976D2"
                />
                <MenuCard
                    link="/inventory-transfer-item"
                    title="Transfer Items"
                    icon={faListCheck}
                    color="#5E35B1"
                />
                <MenuCard
                    link="/inventory-adjustment"
                    title="Inventory Adjustment"
                    icon={faSliders}
                    color="#F57C00"
                />
                <MenuCard
                    link="/warehouse"
                    title="Warehouse"
                    icon={faWarehouse}
                    color="#795548"
                />

                <MenuCard
                    link="/warehouse-bin"
                    title="Warehouse Bin"
                    icon={faBoxesStacked}
                    color="#5D4037"
                />

                <MenuCard
                    link="/warehouse-stock"
                    title="Warehouse Stock"
                    icon={faBoxes}
                    color="#00897B"
                />

                <MenuCard
                    link="/goods-receipt"
                    title="Goods Receipt"
                    icon={faTruckLoading}
                    color="#2E7D32"
                />
                <MenuCard
                    link="/goods-receipt-item"
                    title="Goods Receipt Item"
                    icon={faClipboardList}
                    color="#43A047"
                />

                <MenuCard
                    link="/goods-issue"
                    title="Goods Issue"
                    icon={faDolly}
                    color="#EF6C00"
                />
                <MenuCard
                    link="/goods-issue-item"
                    title="Goods Issue Item"
                    icon={faDolly}
                    color="#FB8C00"
                />
                <MenuCard
                    link="/machine-category"
                    title="Machine Category"
                    icon={faTags}
                    color="#5E35B1"
                />
                <MenuCard
                    link="/machine"
                    title="Machine"
                    icon={faTractor}
                    color="#388E3C"
                />
                <MenuCard
                    link="/machine-booking"
                    title="Machine Booking"
                    icon={faCalendarCheck}
                    color="#00897B"
                />
                <MenuCard
                    link="/machine-usage"
                    title="Machine Usage"
                    icon={faGaugeHigh}
                    color="#7B1FA2"
                />
                <MenuCard
                    link="/machine-payment"
                    title="Machine Payment"
                    icon={faMoneyCheckDollar}
                    color="#2E7D32"
                />
                <MenuCard
                    link="/machine-image"
                    title="Machine Image"
                    icon={faImages}
                    color="#6A1B9A"
                />

            </>)}
            {userGroup === "LandOwner" && (<>
                <MenuCard
                    link="/owner-dispute/"
                    title="Disputes"
                    icon={faTriangleExclamation}
                    color="#dc3545"
                />
                <MenuCard
                    link="/owner-dashboard/"
                    title="Owner Dashboard"
                    icon={faChartLine}
                    color="#0d6efd"
                />

            </>)}
            {/* ================= WORKER ================= */}

            {userGroup === "Worker" && (<>

                <MenuCard
                    link="/worker-dashboard/"
                    title="Worker Dashboard"
                    icon={faChartLine}
                    color="#0d6efd"
                />
                <MenuCard
                    link="/apply-work/"
                    title="Find Jobs"
                    icon={faBriefcase}
                    color="#fd7e14"
                />

                <MenuCard
                    link="/work-task/"
                    title="My Tasks"
                    icon={faTasks}
                    color="#0d6efd"
                />
                <MenuCard
                    link="/worker-rating"
                    title="Worker Rating"
                    icon={faStar}
                    color="#FF9800"
                />
                <MenuCard
                    link="/worker-notification"
                    title="Worker Notification"
                    icon={faBell}
                    color="#00796B"
                />

            </>)}

        </div>

    </section>);
}
export default Menu;